<template>
  <div id="app">
    <ApiErrorModal v-if="$store.state.isApiDown" />
    <div
      :class="{
        'swoosh-bg': $route.name !== 'failure' && $route.name !== 'results'
      }"
    ></div>
    <!-- slick nav -->
    <!-- <nav>
      <h1 class="title"><b>Travel</b> by Investec</h1>
    </nav>-->
    <!--  funcky tbi nav -->
    <!-- <nav-bar></nav-bar> -->
    <tbi-nav-bar />
    <div class="browser-upgrade-prompt" v-if="!browserSupport">
      Your browser is out-of-date, and may result in style and functionality
      issues, please consider updating to a modern alternative:
      <br />
      <a
        href="https://www.google.com/chrome/?brand=CHBD&gclid=Cj0KCQjwpPHoBRC3ARIsALfx-_LORIy1A83i_ZjeeZyqcTDeOQjrTpiFXldHwybG3DHshaKeRhKS6jgaAqLhEALw_wcB&gclsrc=aw.ds"
        >Google Chrome</a
      >
      <br />
      <a href="https://www.mozilla.org/en-US/firefox/new/">Mozilla Firefox</a>
    </div>

    <section
      :class="{
        'route-wrapper': !$route.name === 'confirmation',
        'z-1':
          ($route.name === 'search' || $route.name === 'results') &&
          !$store.state.isApiDown
      }"
    >
      <router-view />
    </section>

    <FooterDesktop class="footer-desktop" />
    <FooterMobile class="footer-mobile" />
  </div>
</template>

<script>
const { detect } = require("detect-browser");
const browser = detect();
import TbiNavBar from "@/components/investec/Navigation/NavBar.vue";
import FooterDesktop from "@/components/investec/FooterDesktop.vue";
import FooterMobile from "@/components/investec/FooterMobile.vue";
import ApiErrorModal from "@/components/ApiErrorModal.vue";
import {
  fetchProductHealth,
  HEALTHY_POLL_INTERVAL_MS,
  UNHEALTHY_POLL_INTERVAL_MS
} from "@/services/apiHealth.service.js";

import { mapState } from "vuex";

export default {
  data() {
    return {
      browserSupport: true,
      windowWidth: window.innerWidth,
      isSmallDevice: 768,
      healthPollTimer: null
    };
  },
  computed: {
    ...mapState(["invsyUser", "isIframe"])
  },
  mounted() {
    this.checkApiHealth();
    switch (browser && browser.name) {
      case "ie":
        console.log("Internet Explorer Detected, consider upgrade");
        this.browserSupport = false;
        break;
      default:
        console.log(browser.name);
        console.log("browser supported");
    }
    if (window !== window.parent) {
      this.$store.dispatch("initializeInvsy");
    }
    window.addEventListener("resize", this.updateWindowWidth);
  },
  destroyed() {
    this.clearHealthPoll();
    window.removeEventListener("resize", this.updateWindowWidth);
  },
  methods: {
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    clearHealthPoll() {
      if (this.healthPollTimer) {
        clearInterval(this.healthPollTimer);
        this.healthPollTimer = null;
      }
    },
    scheduleHealthPoll(isUnhealthy) {
      this.clearHealthPoll();
      const interval = isUnhealthy
        ? UNHEALTHY_POLL_INTERVAL_MS
        : HEALTHY_POLL_INTERVAL_MS;
      this.healthPollTimer = setInterval(() => this.checkApiHealth(), interval);
    },
    async checkApiHealth() {
      const result = await fetchProductHealth("flights");

      if (result.healthy) {
        if (this.$store.state.isApiDown) {
          this.$store.commit("setApiHealthy");
        }
        this.scheduleHealthPoll(false);
        return;
      }

      this.$store.commit("setApiDown", result.errorCode);
      this.scheduleHealthPoll(true);
    }
  },
  components: {
    TbiNavBar,
    FooterDesktop,
    FooterMobile,
    ApiErrorModal
  }
};
</script>

<style lang="scss">
@import "./assets/styles/settings.scss";
* {
  box-sizing: border-box;
}
html {
  overscroll-behavior: none; /* Chrome 140+ requires this on html element, not body */
}
html,
body {
  max-width: 100%;
  overflow-x: hidden;
  background: #fff;
  margin: 0;
  padding-bottom: env(safe-area-inset-bottom);
}
</style>

<style lang="scss" scoped>
@import "./assets/styles/settings.scss";

// By default, show the mobile footer and hide the desktop footer
.footer-desktop {
  display: none;
}
.footer-mobile {
  display: block;
}
.browser-upgrade-prompt {
  margin: 20px;
  padding: 20px;
  border: 2px solid black;
  border-radius: 8px;
  font-size: 20px;
  font-weight: bold;
  background: white;
}

.route-wrapper {
  margin: 30px 1em;
  max-width: -webkit-fill-available;
}

#app {
  background: #f6f6f4;
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  text-align: left;
}

.z-1 {
  z-index: 13;
}

.swoosh-bg {
  background-image: url("assets/images/background-swoosh.svg") !important;
  background-size: cover !important;
  background-position: center !important;
  background-repeat: no-repeat !important;
  width: 100% !important;
  position: absolute;
  height: 70%;
  z-index: 0;
}

@media (max-width: 781px) {
  .swoosh-bg {
    background-image: url("assets/images/background-swoosh.svg") !important;
    background-size: unset !important;
    background-position: unset !important;
    background-repeat: no-repeat !important;
    width: 100% !important;
    position: absolute;
    height: 70%;
    z-index: 0;
  }
}

@media (min-width: 1295px) {
  .route-wrapper {
    margin: 70px 1em;
  }
  .footer-desktop {
    display: block;
  }
  .footer-mobile {
    display: none;
  }
}
</style>
